import { formatDate, getAvatarUrl } from "src/Common/common";
import { vocabularize } from "src/Common/vocab";
import { can } from "src/Common/function";
import WOStatusComponent from "../Components/Status/wostatuscomponent";
import WoType from "src/Pages/WO/Components/Types/WoType";
import TechnicianStatus from "../Components/TechnicianStatus";
import ApproveRequestButton from "src/Components/Common/approverequestbutton";
import DenyRequestButton from "src/Components/Common/denyrequestbutton";
import BlueServiceTicketButton from "../Components/serviceticketbuttons/blueserviceticketbutton";
import ServiceTicketButton from "../Components/serviceticketbuttons/serviceticketbutton";
import { getImageUrl } from "src/Common/common";
import { Tooltip } from "react-tooltip";

function Field({ label, children }) {
  return (
    <div className="flex flex-col justify-start items-start gap-1">
      <div className="text-[#7C829A] font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] uppercase">
        {label}
      </div>
      <div className="self-stretch text-[#1A2332] font-OpenSansSemiBold text-[14px] leading-5 tracking-[0.14px] capitalize break-words">
        {children}
      </div>
    </div>
  );
}

function PersonValue({ avatar, name, fallback = "—" }) {
  if (!name) {
    return <span className="text-[#1A2332] font-OpenSansSemiBold text-[14px] leading-5">{fallback}</span>;
  }
  return (
    <div className="flex items-center gap-2">
      <img src={getAvatarUrl(avatar)} className="w-5 h-5 rounded-full" alt="" />
      <span className="capitalize">{name}</span>
    </div>
  );
}

export default function ServiceCall({
  order,
  stPreviewLoading,
  onEditDetails,
  onPreviewServiceTicket,
  onViewServiceTicket,
  onAddBilledDate,
  onEditAssignedTechs,
  onAssignTechs,
  onApprove,
  onDeny,
}) {
  return (
    <div className="w-full pb-6 bg-white rounded-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] border border-[#E5E8F3] flex flex-col justify-start items-stretch overflow-hidden">
      {/* Header */}
      <div className="self-stretch px-6 py-4 bg-slate-50 border-b border-slate-200 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="text-[#1A2332] font-OpenSansSemiBold text-[14px] leading-5 tracking-[0.14px]">
            Service Call
          </span>
          <span data-testid="wo-status-badge"><WOStatusComponent value={order.status} /></span>
        </div>
        <div className="flex items-center gap-2">
          {can("wo:update") && (
            <>
              <button
                type="button"
                onClick={onEditDetails}
                data-testid="wo-edit-details"
                data-tooltip-id="edit-wo-details"
                data-tooltip-content={vocabularize("Edit Work Order Details")}
                className="w-[32px] h-[32px] rounded-lg border border-[#C9CEE2] bg-white flex items-center justify-center cursor-pointer shadow-[0_1px_2px_0_rgba(16,24,40,0.05)]"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                  <path
                    d="M12.4994 11.3332C12.7755 11.3332 12.9994 11.557 12.9994 11.8332C12.9994 12.1093 12.7755 12.3332 12.4994 12.3332H6.49938C6.22323 12.3332 5.99938 12.1093 5.99938 11.8332C5.99938 11.557 6.22323 11.3332 6.49938 11.3332H12.4994Z"
                    fill="#1A2332"
                  />
                  <path
                    d="M11.3327 1.91536C11.3327 1.6727 11.2361 1.43985 11.0645 1.26823C10.8929 1.0966 10.6601 1 10.4174 1C10.1747 1 9.94185 1.09661 9.77022 1.26823L1.76306 9.27539C1.664 9.3744 1.59138 9.49707 1.55213 9.63151L1.07817 11.2539L2.70121 10.7806C2.83572 10.7414 2.95891 10.6687 3.05798 10.5697L11.0645 2.5625C11.2361 2.39092 11.3327 2.158 11.3327 1.91536ZM12.3327 1.91536C12.3327 2.42322 12.1306 2.91042 11.7715 3.26953L3.76502 11.2767C3.54696 11.4947 3.27724 11.654 2.98116 11.7402L1.06645 12.2988C0.923129 12.3406 0.770948 12.3437 0.626344 12.3066C0.481734 12.2696 0.349769 12.1941 0.244183 12.0885C0.138548 11.9829 0.0631595 11.8504 0.0260841 11.7057C-0.010928 11.5611 -0.00856058 11.409 0.0332455 11.2656L0.591839 9.35091C0.678205 9.05516 0.838116 8.78617 1.05603 8.56836L9.06319 0.561198C9.42235 0.20204 9.90943 4.37772e-06 10.4174 0C10.9253 0 11.4124 0.202037 11.7715 0.561198C12.1306 0.92035 12.3327 1.40748 12.3327 1.91536Z"
                    fill="#1A2332"
                  />
                  <path
                    d="M8.14586 1.47964C8.34112 1.28438 8.65763 1.28438 8.85289 1.47964L10.8529 3.47964C11.0482 3.6749 11.0482 3.99141 10.8529 4.18667C10.6576 4.38193 10.3411 4.38193 10.1459 4.18667L8.14586 2.18667C7.9506 1.99141 7.9506 1.6749 8.14586 1.47964Z"
                    fill="#1A2332"
                  />
                </svg>
              </button>
              <Tooltip id="edit-wo-details" positionStrategy="fixed" />
            </>
          )}
          {order.status >= 5 ? (
            <BlueServiceTicketButton clicked={onViewServiceTicket} />
          ) : (
            <ServiceTicketButton clicked={onPreviewServiceTicket} isLoading={stPreviewLoading} />
          )}
        </div>
      </div>

      {/* Body */}
      <div className="w-full flex justify-between items-stretch gap-6 px-6 pt-5">
        {/* Left: details grid */}
        <div className="flex-1 min-w-0 grid grid-cols-2 gap-x-6 gap-y-5">
          <Field label="Type">{order.serviceType ? <WoType serviceType={order.serviceType} /> : "—"}</Field>
          <Field label="Customer Purchase Order">{order.customerPONumber ? `# ${order.customerPONumber}` : "—"}</Field>
          <Field label="Start Date">{order.startDateString || "—"}</Field>
          <Field label="Opened On">{order.openDate ? formatDate(order.openDate) : "—"}</Field>
          <Field label="NTE Amount">{order.NTE ? `$${order.NTE}` : "—"}</Field>
          {order.status === 0 ? (
            <Field label="Requested By">
              <PersonValue avatar={order.requestedCustomerUser?.avatar} name={order.requestedCustomerUser?.name} />
            </Field>
          ) : (
            <Field label="Issued By">
              <PersonValue avatar={order.openUser?.avatar} name={order.openUser?.name} />
            </Field>
          )}
          {order.quotedBy && (
            <Field label="Quoted By">
              <PersonValue avatar={order.quotedBy.avatar} name={order.quotedBy.name} />
            </Field>
          )}
          <Field label={vocabularize("Asset")}>
            <span className={order.asset ? "" : "text-[#7C829A] italic font-OpenSansRegular"}>
              {order.asset || "Not Specified"}
            </span>
          </Field>
          <div className="col-span-2 flex flex-col justify-start items-start gap-1">
            <div className="text-[#7C829A] font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] uppercase">
              Description
            </div>
            <div className="self-stretch text-[14px] leading-5 break-words">
              {order.description ? (
                <span className="text-[#1A2332] font-OpenSansSemiBold">{order.description}</span>
              ) : (
                <span className="text-[#7C829A] italic font-OpenSansRegular">
                  {vocabularize("No description provided for this work order.")}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Middle: Date Billed */}
        {can("wo:readDateBilled") && (
          <div className="w-[26%] flex flex-col justify-start items-start gap-3 pl-6 border-l border-[#E5E8F3]">
            <div className="text-[#7C829A] font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] uppercase">
              Date Billed
            </div>
            <div className="self-stretch flex flex-col gap-3 max-h-[220px] overflow-y-auto">
              {order.billedData?.map((item, index) => (
                <div className="flex flex-col" key={index}>
                  <div className="flex items-center gap-1">
                    <img src={getImageUrl("/images/wo/date.svg")} alt="" />
                    <span className="text-[14px] font-OpenSansSemiBold text-[#1A2332]">{item.date}</span>
                  </div>
                  <span className="text-[#1A2332] font-OpenSansRegular text-[14px] leading-5 tracking-[0.14px] break-words">
                    {`Note: ${item.note}`}
                  </span>
                </div>
              ))}
            </div>
            {can("wo:addDateBilled") && order.status >= 1 && (
              <button
                type="button"
                onClick={onAddBilledDate}
                className="flex items-center gap-1 text-[#0065FD] font-OpenSansSemiBold text-[14px] leading-5 tracking-[0.14px] capitalize cursor-pointer"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                  <path
                    d="M9.83333 4.66667C10.1095 4.66667 10.3333 4.89052 10.3333 5.16667C10.3333 5.44281 10.1095 5.66667 9.83333 5.66667H0.5C0.223858 5.66667 0 5.44281 0 5.16667C0 4.89052 0.223858 4.66667 0.5 4.66667H9.83333Z"
                    fill="#0065FD"
                  />
                  <path
                    d="M4.66667 9.83333V0.5C4.66667 0.223858 4.89052 0 5.16667 0C5.44281 0 5.66667 0.223858 5.66667 0.5V9.83333C5.66667 10.1095 5.44281 10.3333 5.16667 10.3333C4.89052 10.3333 4.66667 10.1095 4.66667 9.83333Z"
                    fill="#0065FD"
                  />
                </svg>
                <span>Add</span>
              </button>
            )}
          </div>
        )}

        {/* Right: Assigned To */}
        <div className="w-[26%] flex flex-col justify-start items-start gap-3 pl-6 border-l border-[#E5E8F3]">
          <div className="text-[#7C829A] font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] uppercase">
            Assigned To
          </div>
          <div className="self-stretch flex flex-col gap-2 max-h-[220px] overflow-y-auto">
            {order.assignedTechs?.map((tech, index) => (
              <div className="flex items-center gap-2" key={index}>
                <img src={getAvatarUrl(tech.user.avatar)} className="w-[20px] h-[20px] rounded-full" alt="" />
                <span data-testid="wo-assigned-tech" className="text-[14px] font-OpenSansSemiBold text-[#1A2332] capitalize">{tech.user.name}</span>
                {tech.status === 1 ? (
                  <img src={getImageUrl("/images/common/check.png")} className="w-5 h-5" alt="" />
                ) : tech.status === 2 ? (
                  <img src={getImageUrl("/images/common/red_close.png")} className="w-5 h-5" alt="" />
                ) : null}
                <TechnicianStatus status={tech.techStatus} />
              </div>
            ))}
          </div>
          {can("wo:assignTech") &&
            order.status > 0 &&
            (order.assignedTechs?.length > 0 ? (
              <button
                type="button"
                onClick={onEditAssignedTechs}
                className="flex items-center gap-1 text-[#0065FD] font-OpenSansSemiBold text-[14px] leading-5 tracking-[0.14px] capitalize cursor-pointer"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M13.9999 12.8332C14.276 12.8332 14.4999 13.057 14.4999 13.3332C14.4999 13.6093 14.276 13.8332 13.9999 13.8332H7.99986C7.72372 13.8332 7.49986 13.6093 7.49986 13.3332C7.49986 13.057 7.72372 12.8332 7.99986 12.8332H13.9999Z"
                    fill="#0065FD"
                  />
                  <path
                    d="M12.8332 3.41536C12.8332 3.1727 12.7365 2.93985 12.565 2.76823C12.3934 2.5966 12.1606 2.5 11.9178 2.5C11.6751 2.5 11.4423 2.59661 11.2707 2.76823L3.26355 10.7754C3.16449 10.8744 3.09187 10.9971 3.05261 11.1315L2.57866 12.7539L4.2017 12.2806C4.33621 12.2414 4.4594 12.1687 4.55847 12.0697L12.565 4.0625C12.7366 3.89092 12.8332 3.658 12.8332 3.41536ZM13.8332 3.41536C13.8332 3.92322 13.6311 4.41042 13.272 4.76953L5.2655 12.7767C5.04744 12.9947 4.77773 13.154 4.48165 13.2402L2.56694 13.7988C2.42362 13.8406 2.27144 13.8437 2.12683 13.8066C1.98222 13.7696 1.85026 13.6941 1.74467 13.5885C1.63904 13.4829 1.56365 13.3504 1.52657 13.2057C1.48956 13.0611 1.49193 12.909 1.53373 12.7656L2.09233 10.8509C2.17869 10.5552 2.3386 10.2862 2.55652 10.0684L10.5637 2.0612C10.9228 1.70204 11.4099 1.5 11.9178 1.5C12.4258 1.5 12.9129 1.70204 13.272 2.0612C13.6311 2.42035 13.8332 2.90748 13.8332 3.41536Z"
                    fill="#0065FD"
                  />
                  <path
                    d="M9.64635 2.97964C9.84161 2.78438 10.1581 2.78438 10.3534 2.97964L12.3534 4.97964C12.5486 5.1749 12.5486 5.49141 12.3534 5.68667C12.1581 5.88193 11.8416 5.88193 11.6463 5.68667L9.64635 3.68667C9.45109 3.49141 9.45109 3.1749 9.64635 2.97964Z"
                    fill="#0065FD"
                  />
                </svg>
                <span>Edit</span>
              </button>
            ) : (
              <button
                type="button"
                data-testid="wo-assign-techs"
                onClick={onAssignTechs}
                className="flex items-center gap-1 text-[#0065FD] font-OpenSansSemiBold text-[14px] leading-5 tracking-[0.14px] capitalize cursor-pointer"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                  <path
                    d="M9.83333 4.66667C10.1095 4.66667 10.3333 4.89052 10.3333 5.16667C10.3333 5.44281 10.1095 5.66667 9.83333 5.66667H0.5C0.223858 5.66667 0 5.44281 0 5.16667C0 4.89052 0.223858 4.66667 0.5 4.66667H9.83333Z"
                    fill="#0065FD"
                  />
                  <path
                    d="M4.66667 9.83333V0.5C4.66667 0.223858 4.89052 0 5.16667 0C5.44281 0 5.66667 0.223858 5.66667 0.5V9.83333C5.66667 10.1095 5.44281 10.3333 5.16667 10.3333C4.89052 10.3333 4.66667 10.1095 4.66667 9.83333Z"
                    fill="#0065FD"
                  />
                </svg>
                <span>Add</span>
              </button>
            ))}
        </div>
      </div>

      {/* Approve / Deny request */}
      {order.status === 0 && can("wo:approve") && (
        <div className="w-full flex items-center justify-end px-6 pt-4">
          <div className="flex items-center gap-2">
            <DenyRequestButton onClicked={onDeny} />
            <ApproveRequestButton onClicked={onApprove} />
          </div>
        </div>
      )}
    </div>
  );
}
